import { useTranslation } from "react-i18next";
import { Uniter } from "../../../../../helbest";
import styles from "./OrderItem.module.css";
import NoImage from "../../../../../assets/images/base/no-image.png";

const OrderItem = (props) => {
  const {
    product_name,
    quantity,
    thumbnail,
    total_discount,
    item_price,
    total_price,
    payable_amount,
    currency,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.BoxOrderItem}>
      <div className={styles.Content}>
        <div className={styles.ItemHeader}>
          <img
            fill
            style={{ width: "64px" }}
            src={thumbnail ? thumbnail.url : NoImage}
            alt={thumbnail?.alt || product_name}
          />
          <div className={styles.TextInfo}>
            <div className="w-full">
              <span> {product_name} </span>
            </div>
            <div>
              <label>{t("orderitem.quantity")}</label>
              <span> {quantity} </span>
            </div>
          </div>
        </div>
        <div className={`${styles.Separator}`} />

        <div style={{ marginBottom: "8px" }}>
          {t("orderitem.item_price")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {item_price}
          </Uniter>
        </div>

        <div>
          {t("summery.price")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {total_price}
          </Uniter>
        </div>

        <div>
          {t("summery.discount")}
          <Uniter unit={currency} className={styles.Unit_Amount}>
            {total_discount}
          </Uniter>
        </div>

        <div className={`${styles.Separator}`} />
        <div className={styles.PaidAmount}>
          {t("summery.payable")}
          <Uniter unit={currency} unit_bold>
            {payable_amount}
          </Uniter>
        </div>
      </div>
    </div>
  );
};

export default OrderItem;